













































































































































import { Component, Vue } from "vue-property-decorator";
import { PageInfo } from "@/model/Resp";
import {
  getWheelOfFortuneExcel,
  getCampaignMeasureStatistics,
  getCampaignMeasureDetail
} from "@/services/api";
import {TFormVO} from "@/model/FormWheel";
import {handleExcelRes} from "@/services/common";
import { getPickerOptions, getMonthFirstDay,dateFormat } from "@/services/common";

interface paneitem {
  label: string;
  value: string;
  count:number;
}

@Component({})
export default class wheelOfFortuneList extends Vue {
  paneList: paneitem[]=[
    {label:'发送',value:'Send',count:0},
    {label:'过滤',value:'Filter',count: 0},
    {label:'打开',value:'Open',count:0},
    {label:'点击',value:'Click',count:0},
    {label:'下单',value:'Orders',count:0},
    {label:'退回',value:'Bounce',count:0},
    {label:'退订',value:'Unsubscribe',count:0},
    {label:'投诉',value:'Complaint',count:0},
  ]

  paneActiveName :string = 'Send'
  value2 = ''

  tableData: TFormVO[] = [];

  pageInfo: PageInfo = {
    currentPage: 1,
    pageSize: 20,
    total: 0,
  };

  date:Date[]| null = [dateFormat('YYYY-mm-dd 00:00:00',new Date(new Date().setHours(0, 0, 0, 0) - 30 * 24 * 60 * 60 * 1000)),
   dateFormat('YYYY-mm-dd 00:00:00',new Date())]

  queryEmails:string[] = []

  order = null
  prop = null

  created(): void {
    this.getCampaignMeasureStatistics(this.$route.params.id);
    this.getCampaignMeasureDetail(this.$route.params.id);
  }

  goOrderUrl(e:string){
      window.open(e)
  }

  gettaskStatus(scope:any) {return {
    WaitSend: "待发送", 
    Delivered: "已发送",
    Bounce: "退回", 
    ConditionFilter:"条件过滤",
    BlackListFilter:"黑名单过滤",
    IntelligentSendFilter: '智能过滤',
    BounceFilter : '黑名单过滤'
    }[scope as 'WaitSend'|"Delivered"|'Bounce'|"ConditionFilter"|"BlackListFilter" |"IntelligentSendFilter" |'BounceFilter']}

  handleClick(vm:any,event:string){
    this.paneActiveName = vm.name
    this.order = null
    this.prop = null
    this.pageInfo.pageSize = 10;
    this.pageInfo.currentPage = 1;
    this.queryEmails = []
    this.value2 = ''
    this.$refs.multipleTable?.clearSort()
    this.getCampaignMeasureDetail(this.$route.params.id);
  }

  changeEmail(e:string){
     let a = e.trim()
    if (a.length) {
      this.queryEmails = a.split(/[(\r\n)\r\n,]+/)
    }else{
      this.queryEmails = []
    }
    this.getCampaignMeasureDetail(this.$route.params.id);
  }
  getclass(scope:any){return '__status--' + { 0:'suspend',1 :'running'}[scope.row.status as 1 | 0]}

  //显示空值
  formatterChangeNUll(r:any, c:any, v:any){return  v === 0?'$0':(`$${v}` || '-')}

  sortChange(data:any){
    this.order = data?.order
    this.prop = data?.prop
    this.getCampaignMeasureDetail(this.$route.params.id);
  }

  //
  getColumn( isShow:boolean, val:string, val2?:string){
    if(this.paneActiveName === val || this.paneActiveName === val2){
      return isShow
    }
    return true
  }

 async getCampaignMeasureStatistics (id:string ){

  let params = { 
      campaignId: id,
    }
    let {status ,data } =  await getCampaignMeasureStatistics(params, true)
    if(status == 200){
      this.paneList = [
        {label:'发送',value:'Send',count: data.data.sendCount},
        {label:'过滤',value:'Filter',count: data.data.filterCount},
        {label:'打开',value:'Open',count: data.data.openCount},
        {label:'点击',value:'Click',count: data.data.clickCount},
        {label:'下单',value:'Orders',count: data.data.orderDetailCount},
        {label:'退回',value:'Bounce',count:data.data.bounceCount},
        {label:'退订',value:'Unsubscribe',count:data.data.unsubscribeCount},
        {label:'投诉',value:'Complaint',count:data.data.complaintCount},
      ]
    }

 }
 async getCampaignMeasureDetail (id:string ){

  let params = { 
      id: id,
      measureName: this.paneActiveName && this.paneActiveName,
      queryEmails: this.queryEmails,
      sortType: this.order && (this.order === 'ascending'? 'ASC' :'DESC'),
      sortFieldName:  this.order && this.prop,
      currentPage: this.pageInfo.currentPage,
      pageSize: this.pageInfo.pageSize
    }
    let {status ,data } =  await getCampaignMeasureDetail(params, true)
    if(status == 200){
       this.tableData = data.data
        this.pageInfo = data.pageInfo ? data.pageInfo : {currentPage: 1, allPage: 0, pageSize: 10, total: 0} as PageInfo;
    }

 }



  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.pageInfo.pageSize = val;
    this.pageInfo.currentPage = 1;
    this.getCampaignMeasureDetail(this.$route.params.id);
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.pageInfo.currentPage = val;
    this.getCampaignMeasureDetail(this.$route.params.id);
  }

  /**
   * 数据导出
   */
  public excelCtrl = true;
  async getExcel(id: string,signupCnt: number): Promise<void>  {
    if (!signupCnt) {
      this.$message('暂无数据');
      return;
    }
    if (this.excelCtrl) {
      try {
        this.excelCtrl = false;
        await getWheelOfFortuneExcel({id}).then((res: any) => {
          handleExcelRes(res);
        })
      } catch (e) {}
      this.excelCtrl = true;
    }
  }
}
